import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Link, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import loginimg from '../Assets/Images/forget.png';
import logo from '../Assets/Images/Caduceus 512x512.gif';
import { useForm } from 'react-hook-form';
import { BASE_URL, FORGOT_PASSWORD } from '../API';
import { toast } from 'react-toastify';
import axios from 'axios';

function EmailSentConfrimation() {
  const location = useLocation();
  const EMAIL = location.state?.email;
  const { handleSubmit } = useForm();
  const [timer, setTimer] = useState(59);
  const [sendEmail, setSendEmail] = useState(EMAIL);

  useEffect(() => {
    let timerId;
    if (!sendEmail && timer > 0) {
      timerId = setInterval(() => { setTimer((prevTimer) => prevTimer - 1) }, 1000);
    }
    if (timer === 0) { setSendEmail(true) }
    return () => clearInterval(timerId);
  }, [sendEmail, timer]);

  const submitHandler = async (data) => {
    try {
      const emailDomain = data?.email?.split('@')[1];
      const emailProviders = {
        'gmail.com': 'https://mail.google.com',
        'yahoo.com': 'https://mail.yahoo.com',
        'outlook.com': 'https://outlook.live.com',
        'hotmail.com': 'https://outlook.live.com',
        'yopmail.com': 'https://yopmail.com'
      };
      const redirectUrl = emailProviders[emailDomain] || 'mailto:';
      window.open(redirectUrl, '_blank');
    } catch (error) {
      toast.error('Error redirecting to email client.');
      console.error(error);
    }
  }

  const handleResendClick = async () => {
    try {
      const email = sendEmail;
      const language = "ENGLISH"
      if (!email) {
        toast.error('No email found. Please try again.');
        return;
      }
      const response = await axios.post(BASE_URL + FORGOT_PASSWORD, { email, language })
      if (response.status === 200) {
        toast.success("Email has been resent successfully.")
        setSendEmail(false);
        setTimer(59);
      }
    }
    catch (error) {
      let err = ''
      if (error.response.data.error_message) { err = error.response.data.error_message }
      else { err = error.response.data.error_description }
      toast.error(err)
    }
  }

  return (
    <>
      <section className="login-section">
        <div className="container-fluid g-0">
          {/* <Header /> */}
          <Row className='row-min-h'>
            <Col lg={6} className='img-n'>
              <div className="upper-fig-main-login">
                <figure className='login-img-main'>
                  <img src={loginimg} alt="" />
                </figure>
              </div>
            </Col>
            <Col lg={6}>
              <div className="inner-login-mian">
                <div className="loginupper-right emailConf">
                  <figure className='creden_page_logo'>
                    <img src={logo} alt="" className='img-fluid' />
                  </figure>
                  <h2>check your inbox, please!</h2>
                  <p className='auth_page_sub_heading'>We have sent a verification link to your email. Please check your inbox (and spam or junk folder if you don’t see it) and click on the link to confirm your email.</p>
                  <Form onSubmit={handleSubmit(submitHandler)}>
                    <Button className='login-btn' type="submit">
                      go to email
                    </Button>
                    <div className="auth-bottom-link-sec">
                      Didn't get the email? {
                        sendEmail ?
                          <Link onClick={handleResendClick}>Resend It</Link> :
                          <span style={{ color: "#9B9B9B" }}>
                            Wait {timer} second{timer !== 1 ? 's' : ''} to resend email.
                          </span>
                      }
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  )
}

export default EmailSentConfrimation